/*
 * @fileOverView SplashScreen component
 */

import Vue from 'vue';
import Blazy from 'blazy';
import EventBus from 'utils/EventBus';
import ViewportHelper from 'utils/ViewportHelper'

/**
 * A reference to the classes used in this view
 *
 * @property CLASSES
 * @type {Object}
 * @private
 */
const CLASSES = {
  'LOADED': 'splashScreen_loaded'
};

/**
 * [SplashScreen Vue]
 * @type {class}
 */
Vue.component('splashscreen-vue', {
  mounted() {
    // The video should only play on first visit with larger screens.
    if (!ViewportHelper.isLargeDesktop() || localStorage.getItem('splashScreen') !== null) {
      EventBus.$emit('splashscreen-video-skipped');
    } else {
      this.saveToLocalStorage();
      this.playVideo();
    }
  },
  created () {
    document.body.addEventListener("mousewheel", this.handleScroll, false);
    document.body.addEventListener("DOMMouseScroll", this.handleScroll, false);
  },
  destroyed () {
    document.body.removeEventListener("mousewheel", this.handleScroll, false);
    document.body.removeEventListener("DOMMouseScroll", this.handleScroll, false);
  },

  methods: {
    /**
     * Plays the video.
     *
     * @method playVideo
     * @public
     */
    playVideo() {
      // This approach ensures the video won't be loaded at smaller page widths.
      this.$refs.video.setAttribute('src', this.$refs.video.getAttribute('data-src'));

      this.$refs.video.addEventListener('loadeddata', () => {
        this.$el.classList.add(CLASSES.LOADED);
      }, false);
    },

    /**
     * Ends the video and emits a global event that video has ended.
     *
     * @method endVideo
     * @public
     */
    endVideo() {
      this.$el.classList.remove(CLASSES.LOADED);

      this.$el.addEventListener("transitionend", event => {
        EventBus.$emit('splashscreen-video-ended');
      }, false);
    },

    /**
     * Handles ending the video when scrolling on window.
     *
     * @method handleScroll
     * @public
     */
    handleScroll() {
      this.endVideo();
    },

    /**
     * Saves info to local storage so it only appears on first visit.
     *
     * @method saveToLocalStorage
     * @public
     */
    saveToLocalStorage() {
      const visited = { "page": "splashScreen", "date": new Date() }

      localStorage.setItem('splashScreen', JSON.stringify(visited));
    }
  }
});
